import React, { useContext } from 'react';
import { useInfoContext } from "../../provider/infoProvider";
import { shCurrencyPipe } from "../../helper/pipes/currency-pipe";
import defaultPaymentInfoServiceInstance from "../../provider/paymentInfoService";
import { AuthContext } from "../../provider/authProvider";
import useInfoState from "../../zustand/infoState";
import useDiscountState from "../../zustand/discountState";

const ShAboPrice = (
    {
        mode = 'month',
        isFixMode = false,
        showMonth = true,
        considerUpgrade = false,
        type = '',
        className,
        onlyNumber = false
    }: {
        mode?: 'month' | 'year',
        isFixMode?: boolean,
        showMonth?: boolean,
        considerUpgrade?: boolean,
        type?: '' | 'basic' | 'duo' | 'family',
        className?: string,
        onlyNumber?: boolean
    }
) => {
    const infoContext = useInfoContext();
    const authContext = useContext(AuthContext);

    const customAboPrice = authContext.currentUserOverview.current?.customAboPrice;
    const showMonthlyPrice = useDiscountState( s => s.showMonthlyPrice);


    if(showMonthlyPrice && !isFixMode){
        mode = 'month';
    }

    let upgradePriceReduction = 0;

    if (considerUpgrade && authContext.currentUserOverview?.current?.upgradePriceReduction) {
        upgradePriceReduction = Number.parseFloat(authContext.currentUserOverview.current.upgradePriceReduction);
    }

    const defaultPaymentInstance = defaultPaymentInfoServiceInstance;
    const price = defaultPaymentInstance.calculatePriceForProduct(
        infoContext?.abo,
        considerUpgrade ? customAboPrice : 0,
        authContext.isGiftcard.current
    );

    let abo;

    if(price){
        abo = (price?.totalPrice - upgradePriceReduction);
    } else{
        abo = (infoContext?.abo?.price - upgradePriceReduction)
    }

    let aboBasic = (useInfoState(s => s.aboBasic?.price) - upgradePriceReduction);
    const aboPriceBasic = defaultPaymentInstance.calculatePriceForProduct(
        infoContext?.aboBasic,
        considerUpgrade ? customAboPrice : 0,
        authContext.isGiftcard.current
    );

    if (aboPriceBasic?.totalPrice) {
        aboBasic = (aboPriceBasic.totalPrice - upgradePriceReduction);
    }


    let aboDuo = (useInfoState(s => s.aboDuo?.price) - upgradePriceReduction);
    let aboFamily = (useInfoState(s => s.aboFamily?.price) - upgradePriceReduction);

    if(mode === "month"){
        if(!onlyNumber){
            abo = shCurrencyPipe(abo / 12);
            aboBasic = shCurrencyPipe(aboBasic / 12);
            aboDuo = shCurrencyPipe(aboDuo / 12);
            aboFamily = shCurrencyPipe(aboFamily / 12);
        } else {
            abo = abo /12;
            aboBasic = aboBasic /12;
            aboDuo = aboDuo /12;
            aboFamily = aboFamily /12;
        }

    } else if(!onlyNumber){
        abo = shCurrencyPipe(abo);
        aboBasic = shCurrencyPipe(aboBasic);
        aboDuo = shCurrencyPipe(aboDuo);
        aboFamily = shCurrencyPipe(aboFamily);
    }


    // round to 2 decimals
    if (onlyNumber) {
        abo = Math.round(abo * 100) / 100;
        aboBasic = Math.round(aboBasic * 100) / 100;
        aboDuo = Math.round(aboDuo * 100) / 100;
        aboFamily = Math.round(aboFamily * 100) / 100;
    }

    return <span className={className}>
            { type === '' && abo}
            { type === 'basic' && aboBasic}
            { type === 'duo' && aboDuo}
            { type === 'family' && aboFamily}

            { (showMonth && mode === 'month') && "/Monat" }
            { (showMonth && mode === 'year') && "/Jahr" }
    </span>

};

export default ShAboPrice;
